export default function clientConfig() {
  const config = {
    codCliente: 2071, //9071 // 2071
    plano: 2,
    tipo: 1,
  }

  return config
}
